import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that displays variant-level article ref.
 * It updates on variant change events using the fetched HTML snapshot.
 */
class ProductArticleRefComponent extends Component {
  requiredRefs = ['articleRefValue'];

  get eventTarget() {
    return this.closest('.shopify-section, dialog');
  }

  connectedCallback() {
    super.connectedCallback();
    const target = this.eventTarget;
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateArticleRef);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.eventTarget;
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateArticleRef);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateArticleRef = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const nextComponent = event.detail.data.html.querySelector(
      `product-article-ref-component[data-block-id="${this.dataset.blockId}"]`
    );
    if (!nextComponent) return;

    const nextValue = nextComponent.querySelector('[ref="articleRefValue"]');
    const value = nextValue?.textContent?.trim() ?? '';

    this.refs.articleRefValue.textContent = value;
    this.style.display = value ? '' : 'none';
  };
}

if (!customElements.get('product-article-ref-component')) {
  customElements.define('product-article-ref-component', ProductArticleRefComponent);
}
